import {customElement, property} from 'lit/decorators.js';
import {html, LitElement} from 'lit';
import {trackAddToWishlist} from '../../../scripts/service/cube-tracking-layer.js';
import {pushToSnackbar} from '../../../scripts/service/snackbar-service.js';
import {getSinglePictureUrl} from '../../../scripts/service/image-formatter.js';

@customElement('ents-wishlist-mail-product-added')
export class MailProductAdded extends LitElement {
  @property({type: Number}) private syan: number | undefined = undefined;

  @property({type: String, attribute: 'color-id'}) private colorId: string | undefined = undefined;

  @property({
    type: Boolean, converter: {
      fromAttribute(value: string | null): unknown {
        return value === 'true';
      }
    }
  }) private duplicate: boolean | undefined = undefined;

  @property({type: String, attribute: 'added-message'}) private addedMessage!: string;
  @property({type: String, attribute: 'duplicate-message'}) private duplicateMessage!: string;

  @property({
    type: String, attribute: 'preview-image', converter: {
      fromAttribute(value: string | null): unknown {
        return value ? getSinglePictureUrl(value, 'webp') : undefined;
      }
    }
  }) private previewImageUrl: string | undefined = undefined;

  @property({type: String, attribute: 'description-text'}) private descriptionText: string | undefined = undefined;

  private interval: NodeJS.Timeout | undefined = undefined;

  private intervalIterations = 0;

  private image: HTMLImageElement | undefined;

  connectedCallback() {
    super.connectedCallback();

    this.trackEvent();

    this.cleanupUrl();

    // Try to load the image as early as possible the minimize layout shift within the snackbar
    if (this.previewImageUrl) {
      this.image = new Image();
      this.image.src = this.previewImageUrl;
    }

    if (this.syan) this.interval = setInterval(this.displaySnackbar.bind(this), 100);
  }

  private trackEvent() {
    if (!this.syan) {
      return;
    }
    trackAddToWishlist({
      identifier: [this.syan, this.colorId].filter(e => typeof e !== 'undefined').join('-'),
      syan: this.syan,
      colorId: this.colorId,
      tracking: {
        context: 'notification',
        placement: 'wishlist',
      },
    });
  }

  private cleanupUrl() {
    const url = new URL(window.location.href);
    url.searchParams.delete('added');
    url.searchParams.delete('duplicate');
    window.history.replaceState({}, '', url.toString());
  }

  private displaySnackbar() {
    if (this.intervalIterations > 10) {
      console.error('Could not display snackbar');
      clearInterval(this.interval);
      return;
    }

    this.intervalIterations++;

    const snackbar = document.querySelector('bdk-snackbar');

    if (!snackbar?.shadowRoot) {
      return;
    }

    if (this.duplicate) {
      pushToSnackbar(
        this.duplicateMessage,
        this.previewImageUrl,
        undefined,
        undefined,
        this.descriptionText
      );
    } else {
      pushToSnackbar(
        this.addedMessage,
        this.previewImageUrl,
        undefined,
        undefined,
        this.descriptionText
      );
    }

    clearInterval(this.interval);
  }

  render() {
    return html`
      <slot/>
    `;
  }
}
